<template>
  <div ref="content" class="show__more flex space-between align-center">
    <div :style="itemStyle" class="show__more__content">
      <slot name="default"></slot>
    </div>
    <el-button @click="clickMultiple" v-if="multiple && showMultipleBtn" class="show__more__btn" plain>
      多选
      <i class="el-icon-arrow-down"></i>
    </el-button>
    <template v-if="showMoreContent">
      <el-button @click="openMore" v-if="showMoreBtn" class="show__more__btn" plain>
        更多
        <i class="el-icon-arrow-down"></i>
      </el-button>
      <el-button @click="hideMore" v-else class="show__more__btn" plain>
        收起
        <i class="el-icon-arrow-up"></i>
      </el-button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    line: {
      type: Number,
      default: 1
    },
    lineHeight: {
      type: Number,
      default: 32
    }
  },
  computed: {
    itemStyle() {
      const style = {
        height: this.height,
        overflow: 'hidden'
      };
      return style;
    }
  },
  data() {
    return {
      showMoreContent: false,
      showMoreBtn: false,
      showMultipleBtn: true,
      height: 'auto'
    };
  },
  methods: {
    init() {
      if (!this.$slots.default) return;
      const limitHeight = this.lineHeight * this.line;
      const { offsetHeight } = this.$refs.content;
      if (offsetHeight > limitHeight) {
        this.height = `${this.lineHeight}px`;
        this.showMoreBtn = true;
        this.showMoreContent = true;
      }
    },
    openMore() {
      this.height = 'auto';
      this.showMoreBtn = false;
    },
    hideMore() {
      this.height = `${this.lineHeight}px`;
      this.showMoreBtn = true;
    },
    clickMultiple() {
      this.height = 'auto';
      this.showMoreBtn = false;
      this.showMultipleBtn = false;
      this.$emit('edit');
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.show__more {
  &__btn {
    align-self: flex-start;
    font-size: 12px;
    font-weight: 400;
    color: #595959;
    line-height: 1;
    border: 1px solid #dedede;
    border-radius: 0;
  }
}
</style>
